module.exports = __webpack_public_path__ + "img/logo.24b94ca0.png";